import React, { Component } from 'react'
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
`;

const TextWrapper = styled.div`
    line-height: 30px;
    font-size: 10px;
    text-align: center;
    color: #545454;
`;

const BoxWraper = styled.div`
    display: flex;
    width: 230px;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 13px;
`;

const Button = styled.div`
    width: 230px;
    line-height: 30px;
    background-color: #62656d;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
`;

const Input = styled.input`
    width: 240px;
    border:0;
    height: 50px;
    background-color: ${props => props.isSelected ? "#62656d" : "#e9ebef"};
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: ${props => props.isSelected ? "#ffffff" : "#545454"};
    line-height: 50px;
    cursor: pointer;
`;


const Error = styled.div`
    width: 231px;
    height: 40px;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 20px;
    padding: 0 13px;
    background-color: #ed1d25;
`;

export default class SMSInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            errorText: "",
            smsText: ""
        };
    }

    componentDidMount() {
        let s = this.hiddenInput;
        this.hiddenInput.focus();
    }

    onChangeSmsText = (e) => {
        let val = e.target.value;
        if (val != undefined) {
            this.setState({
                smsText: val.substring(0, 6)
            })
        }
    }

    onFocusInput = () => {
        this.hiddenInput.focus();
    }

    sendCode = () => {
        let { smsText } = this.state;
        if (smsText && (smsText.length === 5 || smsText.length === 6)) {
            this.props.onSendCode(smsText);
        }
    }

    render() {
        const { title, buttonText } = this.props,
            { smsText, error, errorText } = this.state;
        return (
            <Wrapper>
                <TextWrapper>{title}</TextWrapper>
                <BoxWraper>
                    <Input autoFocus={true} innerRef={x => this.hiddenInput = x} onChange={this.onChangeSmsText} value={smsText}></Input>
                </BoxWraper>
                <Button onClick={this.sendCode}>{buttonText}</Button>

                {
                    error &&
                    <Error>
                        {errorText}
                    </Error>
                }
            </Wrapper>
        )
    }
}
